export const getCurrentOrigin = (onSuccess = () => null, onError = () => null) => {
  navigator.geolocation.getCurrentPosition(onSuccess, onError, {
    timeout: 100,
  });
};

export const convertOrigin = value => {
  return `latitude: ${value.lat} / longitude: ${value.lng}`;
};
